import * as Api from './ApiImplementation';
import * as MockApi from './__mocks__/ApiImplementation';

// This file selects the correct implementation of the API based on the environment variable REACT_APP_BACKEND_URL.
// If REACT_APP_BACKEND_URL is not set, the mock API is used. Otherwise, the real API is used.

export const useMockApi = process.env.REACT_APP_BACKEND_URL == null;

export default useMockApi ? MockApi : Api;